<div class="form-container">
  @if (!user) {
    <h2>User</h2>
    <p>Open this user from the user list to see their details.</p>
    <a [routerLink]="['/dashboard/user/list']" class="btn btn-sm btn-primary">Back to User List</a>
  } @else {
    <h2>User: {{ user.email }}</h2>
    <div class="col-md-8 pl0">
      @for (detail of details; track detail[0]) {
        <div class="row">
          <div class="col-md-3">{{ detail[0] }}</div>
          <div class="col-md-1">:</div>
          <div class="col-md-7">{{ detail[1] }}</div>
        </div>
      }
      <div class="row">
        <div class="col-md-3">Status</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          <span class="badge {{ user.status === 'active' ? 'badge-success' : 'badge-secondary' }}">{{ user.status }}</span>
        </div>
      </div>
      @if (user.customer) {
        <div class="row">
          <div class="col-md-3">Customer</div>
          <div class="col-md-1">:</div>
          <div class="col-md-7">
            @if (auth.hasAccess('PartnerAdmin')) {
              <a [routerLink]="['/dashboard/customer/view', user.customer.id]" [state]="{ data: { customer: user.customer } }">{{ user.customer.name }}</a>
            } @else {
              {{ user.customer.name }}
            }
          </div>
        </div>
      }
      <div class="row">
        <div class="col-md-3">Assigned projects</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          @for (project of user.projects; track project; let last = $last) {
            {{ project.name }}@if (!last) {, }
          } @empty {
            No projects assigned
          }
        </div>
      </div>
      <div class="row footer">
        <a [routerLink]="['/dashboard/user/list']" class="btn btn-sm btn-primary">Back to User List</a>
        <a [routerLink]="['/dashboard/user/edit/', user.id]" [state]="{ data: { user: user } }" class="btn btn-sm btn-edit" title="Edit User">
          <i class="fa fa-fw fa-edit"></i> Edit</a>
        <a [routerLink]="['/dashboard/user/assign/', user.id]" [state]="{ data: { user: user } }" class="btn btn-sm btn-assign" title="Assign Projects">
          <i class="fa fa-fw fa-book"></i> Assign projects</a>
      </div>
    </div>
  }
</div>
